const mockComboCardData = [
    {
        combos: [
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Combo%20Fibra%20Home%20540Mbps"
                },
                
                imagem: "../../assets/images/Combocard/combo1.png",
                titulo: "Combo Fibra Home 540Mbps",
                descricao: "NeT Tri TV com 107 canais abertos",
                tags: [
                    {
                        texto: "Skeelo-Audiobook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Skeelo-Ebook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Super Comics",
                        icone: "promocao",
                                            },
                    {
                        texto: "Wifi Comodato",
                        icone: "wifi",
                                            }
                ],
                faixa: true,
                valor: "119,90",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Combo%20Fibra%20Home%20690Mbps"
                },
                
                imagem: "../../assets/images/Combocard/combo1.png",
                titulo: "Combo Fibra Home 690Mbps",
                descricao: "NeT Tri TV com 107 canais abertos",
                tags: [
                    {
                        texto: "Skeelo-Audiobook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Skeelo-Ebook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Super Comics",
                        icone: "promocao",
                                            },
                    {
                        texto: "Wifi Comodato",
                        icone: "wifi",
                                            }
                ],
                faixa: false,
                valor: "159,90",
               
            },
            

            {
                botoes: {
                    primeiro: "Assine ja !",
                    segundo: "Assine ja !",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Combo%20Fibra%20Home%20390Mbps"
                },
                
                imagem: "../../assets/images/Combocard/combo1.png",
                titulo: "Combo Fibra Home 390Mbps",
                descricao: "NeT Tri TV com 107 canais abertos",
                tags: [
                    {
                        texto: "Skeelo-Audiobook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Skeelo-Ebook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Super Comics",
                        icone: "promocao",
                                            },
                    {
                        texto: "Wifi Comodato",
                        icone: "wifi",
                                            }
                ],
                faixa: false,
                valor: "109,90",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Combo%20Fibra%20Home%201Gb"
                },
                
                imagem: "../../assets/images/Combocard/combo1.png",
                titulo: "Combo Fibra Home 1Gb",
                descricao: "NeT Tri TV com 107 canais abertos",
                tags: [
                    {
                        texto: "Skeelo-Audiobook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Skeelo-Ebook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Super Comics",
                        icone: "promocao",
                                            },
                    {
                        texto: "Wifi Coodato",
                        icone: "wifi",
                                            }
                ],
                valor: "199,90",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Fibra%20Company%20540Mbps"
                },
                
                imagem: "../../assets/images/Combocard/combo2.png",
                titulo: "Fibra Company 540Mbps",
                tags: [
                    {
                        texto: "IP público",
                        icone: "nuvem",
                                            },
                    {
                        texto: "Atendimento Preferencial",
                        icone: "suporte",
                                            },
                    {
                        texto: "Wifi Comodato",
                        icone: "wifi",
                                            }
                ],
                valor: "165,00 mensal",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Fibra%20Company%20690Mbps"
                },
                
                imagem: "../../assets/images/Combocard/combo2.png",
                titulo: "Fibra Company 690Mbps",
                tags: [
                    {
                        texto: "IP público",
                        icone: "nuvem",
                                            },
                    {
                        texto: "Atendimento Preferencial",
                        icone: "suporte",
                                            },
                    {
                        texto: "Wifi Comodato",
                        icone: "wifi",
                                            }
                ],
                valor: "195,00",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Fibra%20Company%201Gb"
                },
                
                imagem: "../../assets/images/Combocard/combo2.png",
                titulo: "Fibra Company 1Gb",
                tags: [
                    {
                        texto: "IP público",
                        icone: "nuvem",
                                            },
                    {
                        texto: "Atendimento Preferencial",
                        icone: "suporte",
                                            },
                    {
                        texto: "Wifi Comodato",
                        icone: "wifi",
                                            }
                ],
                valor: "210,00",
               
            },

            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Combo%20Via%20R%C3%A1dio%2020Mbps"
                },
                
                imagem: "../../assets/images/Combocard/combo3.png",
                titulo: "Combo Via Rádio 20Mbps",
                descricao: "NeT Tri TV com 107 canais abertos",
                tags: [
                    {
                        texto: "Skeelo-Audiobook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Skeelo-Ebook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Super Comics",
                        icone: "promocao",
                                            }
                ],
                valor: "119,90",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Combo%20Via%20R%C3%A1dio%2050Mbps"
                },
                
                imagem: "../../assets/images/Combocard/combo3.png",
                titulo: "Combo Via Rádio 50Mbps",
                descricao: "NeT Tri TV com 107 canais abertos",
                tags: [
                    {
                        texto: "Skeelo-Audiobook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Skeelo-Ebook",
                        icone: "promocao",
                                            },
                    {
                        texto: "Super Comics",
                        icone: "promocao",
                                            }
                ],
                valor: "149,90",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Telefonia%20Fixa"
                },
                
                imagem: "../../assets/images/Combocard/combo4.png",
                titulo: "Telefonia Fixa",
                descricao: "Fixo Local",
                tags: [
                    {
                        texto: "Fixo Local",
                        icone: "telefone",
                                            }
                ],
                valor: "39,90",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Telefonia%20Fixa"
                },
                
                imagem: "../../assets/images/Combocard/combo4.png",
                titulo: "Telefonia Fixa",
                descricao: "Fixo Local+Móvel Local",
                tags: [
                    {
                        texto: "Fixo Local",
                        icone: "telefone",
                                            },
                    {
                        texto: "Móvel Local",
                        icone: "telefone",
                                            }
                ],
                valor: "54,90",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Telefonia%20Fixa"
                },
                
                imagem: "../../assets/images/Combocard/combo4.png",
                titulo: "Telefonia Fixa",
                descricao: "Fixo Nacional+Móvel Local",
                tags: [
                    {
                        texto: "Fixo Nacional",
                        icone: "telefone",
                                            },
                    {
                        texto: "Móvel Local",
                        icone: "telefone",
                                            }
                ],
                valor: "69,00",
               
            },
            {
                botoes: {
                    primeiro: "Assine já!",
                    segundo: "Assine já!",
                    link: "https://api.whatsapp.com/send?phone=554936444444&text=Ol%C3%A1.%20Gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Telefonia%20Fixa"
                },
                
                imagem: "../../assets/images/Combocard/combo4.png",
                titulo: "Telefonia Fixa",
                descricao: "Fixo e Móvel Nacional",
                tags: [
                    {
                        texto: "Fixo Nacional",
                        icone: "telefone",
                                            },
                    {
                        texto: "Móvel Nacional",
                        icone: "telefone",
                                            }
                ],
                valor: "79,90",
               
            }
        ]
    }
];

export default mockComboCardData;